/* eslint-disable no-unused-vars */ 
import papi from '@k4connect/project-camelot-ui-library-papi/papi';
import env from '@k4connect/project-camelot-ui-library-papi/env';
import http from '@k4connect/project-camelot-ui-library-papi/http';
import { computeAvailability } from '@k4connect/project-camelot-ui-library-papi/availability';
import { expand, parseDateFromRRule } from '@k4connect/project-camelot-ui-library-papi/events';

import _ from 'lodash';
import { DateTime } from 'luxon';

import utils from '@k4connect/project-camelot-utils';

import auth from '@/api/auth';
import store from '@/store/index';
import { strings } from "@/plugins/strings";
import { connectionMonitor } from '@/utils/connectionMonitor';
import axios from 'axios';
import { Capacitor } from '@capacitor/core';
import appEnv from '@/api/env';
import { switchCheck } from '@/api/migration';
import { rrulestr } from 'rrule';


export default {

	setup() {
		
	},

	navigation: {
		setLoading(key, value)
		{
			store.dispatch('navigation/loading', { [key]: value })
		}
	},

	alerts: {
		setWarning(text)
		{
			store.dispatch('alerts/warning', text)
		},
		setError(text)
		{
			store.dispatch('alerts/error', text)
		}
	},

	theme: {
		get getDark()
		{
			return store.getters['theme/dark'];
		}
	},

	async loadJwt(jwt) {

		if(jwt) 
		{
			this.jwt = jwt;
		} else {
			this.jwt = await auth.getCredentials();
		}

		http.init(this.navigation, this.alerts, strings);
		env.init(this.theme);

		await papi.init(this.jwt, env);

		return this.jwt;
	},

	async init()
	{
		//note - this can be called multiple times during a long session. It is called by user store after token is refreshed

		await this.loadJwt();

		let session = await this.session();
		
		try {
			const community = store.getters['settings/value']('community')
			const { communityId } = JSON.parse(community);
			const current = utils.guidToId(session._communityId).toString();

			if(current !== communityId)
			{
				const target = utils.idToGuid(communityId, 'association');
				await this.switchCommunity(target);
				session = await this.session();
			}

		} catch(e) {
			console.log('unable to parse stored community from settings', e)
		}

		// The move to 5.x: on the web, ask whether this community has moved, and go to 5.x's sign-in if so.
		if(!Capacitor.isNativePlatform())
		{
			try {
				const href = await switchCheck({ url: appEnv.migration(), jwt: this.jwt, communityId: session._communityId });
				if(href)
				{
					window.location.href = href;
				}
			} catch(e) {
				console.log('unable to check the move to 5.x', e)
			}
		}

		
		const { _id, email, firstName, lastName, preferredName, photo, biography, _roles, _communities, _optOutOfDirectoryFields, _optOutOfDirectory, _communityId } = session;
		
		//resident, staff, family, advocate are all that matter
		const roles = _.map(_roles, (role) => _.startCase(role._name))

		const communities = _.map(_communities, (community) => {
			return {
				_id: utils.guidToId(community._id).toString(),
				name: community._name
			}
		});

		const communityId = utils.guidToId(_communityId).toString();

		const details = await papi.services.my.details();
		const { systems, settings, flags } = details;

		const alexaWakeWord = _.chain(settings).find(['_type', 'alexa']).get('alexa._wakeWord', 'ALEXA').toLower().value();

		const features = _.chain(flags).map((flag) => {
			const { _feature, _enabled } = flag;
			return [ _.camelCase(_feature._parameter), _enabled ]
		}).fromPairs().value();

		const previousLogin = store.getters['user/lastLogin']?.toISOString();
		const recentLogin =  store.getters['settings/value']('lastLogin');

		//lazy load alexaAddressBook for resident users
		if (details.user._type == 'resident' && details.systems && details.systems.length > 0) {
			setImmediate(async () => {
				try {
					await store.dispatch('user/refreshAlexaContactList');
				} catch(e) {
					//ok to fail
				}
			});
		}
		

		return {
			_id, email, lastName,
			firstName: preferredName || firstName,
			fullName: `${ preferredName || firstName } ${ lastName}`,
			biography: biography?.short,
			profileImage: photo,
			communities,
			community: {
				communityId,
				settings: {
					residentVideoCalling: true,
					alexaWakeWord,
					...features
				}
			},
			alexaAddressBook: [],
			roles,
			lastLogin: {
				recentLogin,
				previousLogin
			},
			rooms: _.map(systems, (system) =>  ({ name: system._name })),
			optOutOfDirectory: _optOutOfDirectory,
			hiddenFields: _optOutOfDirectoryFields || []
		};
	},

	async session()
	{
		const { data } = await http.get(`${env.auth()}/session`, {
			headers: {
				authorization: `Bearer ${this.jwt}`
			}
		});
		return data;
	},

	async switchCommunity(_communityId, makeDefault)
	{
		const url = `${env.auth()}/changeCommunity`;

		const response = await http.post(url, {
			_communityId,
			makeDefault: makeDefault ? makeDefault : undefined
		}, {
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${this.jwt}`,
			}
		});

		if(response.status !== 200)
		{
			throw new Error('Access Denied');
		}

		return response.data;

	},

	async createDevice({ _name, _type, _owner })
	{
		return await papi.services.my.device({ _name, _type, _owner });
	},


	async getHomeControls()
	{
		const details = await papi.services.my.details();
		const _communityId = utils.idToGuid(store.getters['user/communityId'], 'association');
		const system = _.find(details.systems, (s)=> s._communityId == _communityId);
		
		if (system) {
			const system = await papi.services.my.system();

			if (_.isNil(system.sysid)) return system;
			const { data: { status } } = await http.post(env.url('api', `/v2/sso/systemStatus/${system.sysid}`), {})

			return {...system, systemStatus: _.capitalize(status), _id: system.sysid };
		}
		
		return;
		
		//const response = await http.get()
		// const response = await this.query({
		// 	query: HomeControlsConfig,
		// 	variables: {
		// 		cred: password,
		// 	},
		// 	fetchPolicy: 'no-cache',
		// })
	
		// return response.data.me.system;


	
	},

	async share(firstName, lastName, email, relationship, primaryPhone = null)
	{
		let camelotRelationship = _.toLower(relationship);

		if (camelotRelationship == 'in_laws') {
			camelotRelationship = 'inLaws'
		} else if (camelotRelationship == 'other') {
			camelotRelationship = 'otherFamily'
		}


		const invite = await papi.services.invites.user({ 
			_firstName: firstName, 
			_lastName: lastName, 
			_email: email, 
			_phone: 
			primaryPhone, 
			_relationship: camelotRelationship, 
			_type: 'family',  
		}, {});

		return {
			inviteMyFriendsOrFamily: {
				matchType: invite._matchType
			}
		}
		// const response = await this.mutate({
		// 	mutation: SendInvite,
		// 	variables: {
		// 		firstName, lastName, email, relationship, primaryPhone
		// 	}
		// })

		// return response.data.me;

	},

	async updateProfile(biography)
	{
		// const communityId = store.getters['user/communityId'];
		const userId = store.getters['user/id'];

		const current = await papi.census.user.getByIdMy(userId);

		// extra fields are provided for schema validation of the patch
		const patches = [{
			op: 'add',
			path: '/biography',
			value: current.biography ? { ...current.biography, short: biography } : { short: biography },
		}]

		await papi.census.user.patchMy(userId, patches);
		
		return {
			data: {
				community: {
					resident: {
						update: {
							_id: userId,
							biography,
							optOutOfDirectory: current._optOutOfDirectory
						}
					}
				}
			}
		}
		
		// return this.mutate({
		// 	mutation: UpdateResident,
		// 	variables: {
		// 		communityId,
		// 		residentId,
		// 		edits: {
		// 			biography
		// 		}
		// 	}
		// })

	},

	async updateOptOutSettings(optOutOfDirectory) {
		
		// const communityId = store.getters['user/communityId'];
		const userId = store.getters['user/id'];

		const current = await papi.census.user.getByIdMy(userId);

		// extra fields are provided for schema validation of the patch
		const updates = {
			firstName: current.firstName,
			lastName: current.lastName,
			_type: current._type,
			_optOutOfDirectory: optOutOfDirectory
		}

		await papi.census.user.patchMy(userId, updates);
		
		return {
			data: {
				community: {
					resident: {
						update: {
							_id: userId,
							biography: current.biography?.short || null,
							optOutOfDirectory
						}
					}
				}
			}
		}


		// const communityId = store.getters['user/communityId'];
		// const residentId = store.getters['user/id'];
		
		// return this.mutate({
		// 	mutation: UpdateResident,
		// 	variables: {
		// 		communityId,
		// 		residentId,
		// 		edits: {
		// 			optOutOfDirectory,
		// 		},
		// 	},
		// });
	},

	async updateOptOutFields(fields) {
		
		// const communityId = store.getters['user/communityId'];
		const userId = store.getters['user/id'];
		
		const camelotFields = _.map(fields, (field)=> {
			switch (field) {
				case 'birthdate':
					return 'birthdate';
				case 'primaryPhone': 
					return 'phone';
				case 'secondaryPhone':
					return 'mobile';
				case 'email':
					return 'email';
			}
		});

		const current = await papi.census.user.getByIdMy(userId);

		await papi.census.user.patchMy(userId, { _optOutOfDirectoryFields: camelotFields, _type: current._type });

		return {
			data: {
				community: {
					hideResidentProperties: {
						resident: {
							_id: userId,
							hiddenFields: [] // always empty
						}
					}
				}
			}
		}

		
		// return this.mutate({
		// 	mutation: HideResidentProperties,
		// 	variables: {
		// 		communityId,
		// 		input:{
		// 			residentId,
		// 			properties: fields
		// 		}
				
		// 	},
		// });
	},

	async updateExposeFields(fields) {
		
		// const communityId = store.getters['user/communityId'];
		// const residentId = store.getters['user/id'];

		const userId = store.getters['user/id'];
		
		const camelotFields = _.map(fields, (field)=> {
			switch (field) {
				case 'birthdate':
					return 'birthdate';
				case 'primaryPhone': 
					return 'phone';
				case 'secondaryPhone':
					return 'mobile';
				case 'email':
					return 'email';
			}
		});

		const current = await papi.census.user.getByIdMy(userId);

		const updated = _.filter(current._optOutOfDirectoryFields, (field)=> !_.includes(camelotFields, field));

		await papi.census.user.patchMy(userId, { _optOutOfDirectoryFields: updated, _type: current._type });

		return {
			data: {
				community: {
					exposeResidentProperties: {
						resident: {
							_id: userId,
							hiddenFields: [] // always empty
						}
					}
				}
			}
		}

		// return this.mutate({
		// 	mutation: ExposeResidentProperties,
		// 	variables: {
		// 		communityId,
		// 		input:{
		// 			residentId,
		// 			properties: fields
		// 		}
				
		// 	},
		// });
	},

	// feed helpers


	async getHome(from, after, limit = 50)
	{
		// const communityId = store.getters['user/communityId'];
		// const audiences = store.getters['user/audiences'];

		const posts = []
		let page = 0;
		// data is passed as cursor in the response
		let data;
		if (!_.isNil(after)) {
			data = JSON.parse(after);
			page = data.page + 1;
			data.page = page;
		} else {
			data = {
				page: -1,
				date: from.toISOString()
			}
		}

		let hasNextPage;

		const broadcastFilter = {}

		if (from && _.isNil(after)) {
			broadcastFilter.sent = { '$gte': from.toISOString(), '$lte': new Date().toISOString() }
		} else {
			broadcastFilter.sent = { '$lt': data.date }
		}

		const broadcasts = await papi.message.broadcast.getMy({ 
			limit: limit + 1, 
			skip: page * limit, 
			populate: 'attachments:file,attachments:video,attachments:image,attachments:link',
			filter: JSON.stringify(broadcastFilter),
			sort: '-sent'
		});


		hasNextPage = broadcasts.length > limit
		if (broadcasts.length > limit) {
			broadcasts.pop(); // remove extra broadcast used to determine if another page exists
		}
		

		for (const broadcast of broadcasts) {
			const notice = {
				_id: broadcast._id,
				title: broadcast.body,
				body: null,
				category: 'Notice',
				author: broadcast.sender,
				startDate: broadcast.sent
			}

			// if both subject and body exist, use the subject as the legacy title and the body as the legacy body
			if (broadcast.subject) {
				notice.title = broadcast.subject;
				notice.body = broadcast.body;
			}

			let assets = [];
			if (_.isArray(broadcast.attachments) && broadcast.attachments.length > 0) {
				assets = _.map(broadcast.attachments, (attachment)=> {
					if (attachment._type == 'file') {
						
						return {
							url: attachment.file.url,
							type: 'Pdf',
							name: attachment.file.title,
							details: { fileType: attachment.file.fileType },
							preview: attachment.file.thumbnail || null
						}

					} else if (attachment._type == 'image') {

						const details = {}

						if (attachment.image.imageType == 'jpg') {
							details.contentType = 'image/jpeg';
						} else if (attachment.image.imageType == 'png') {
							details.contentType = 'image/png';
						}

						return {
							url: attachment.image.url,
							type: 'Photo',
							name: attachment.image.title,
							details,
							preview: attachment.image.thumbnail || attachment.image.url
						}
					} else if (attachment._type == 'link') {
						if (_.includes(attachment.link.url, `forms${env.suffix() == '' ? '-prod' : env.suffix()}-v2.k4connect.com`)) {
							return {
								url: attachment.link.url,
								type: 'Form',
								name: attachment.link.title,
								preview: attachment.link.thumbnail || null
							}
						} else {
							return {
								url: attachment.link.url,
								type: 'Web',
								name: attachment.link.title,
								details: { type: 'web' },
								preview: attachment.link.thumbnail || null
							}
						}
					} else if (attachment._type == 'video') {

						const details = {
							url: attachment.video.url, 
							type: 'video',
							title: attachment.video.title, 
							protocol: 'open-graph'
						}

						return {
							url: attachment.video.url,
							type: 'Web',
							name: attachment.video.title,
							details,
							preview: attachment.video.thumbnail || null
						}
					}
				});
			}

			notice.assets = assets;
			posts.push(notice);
		}

		const postParams = {
			limit: limit + 1, 
			skip: page * limit, 
			populate: 'group:parent.name,attachments:file,attachments:video,attachments:image,attachments:link', 
			sort: '-published',
			_status: 'published'
		}

		if (from && _.isNil(after)) {
			postParams.filter = JSON.stringify({ published: { '$gte': from.toISOString(), '$lte': new Date().toISOString() } })
		} else {
			postParams.filter = JSON.stringify({ published: { '$lt': data.date } });
		}

		// get one more post than the limit to easily compute if another page exists
		const camelotPosts = await papi.content.post.getMy(postParams);

		hasNextPage = hasNextPage || camelotPosts.length > limit;
		if (camelotPosts.length > limit) {
			camelotPosts.pop(); // remove extra post used to determine if another page exists
		}

		for (const post of camelotPosts) {

			let assets = [];
			if (_.isArray(post.attachments) && post.attachments.length > 0) {
				assets = _.map(post.attachments, (attachment)=> {
					if (attachment._type == 'file') {
						
						return {
							url: attachment.file.url,
							type: 'Pdf',
							name: attachment.file.title,
							details: { fileType: attachment.file.fileType },
							preview: attachment.file.thumbnail || null
						}

					} else if (attachment._type == 'image') {

						const details = {}

						if (attachment.image.imageType == 'jpg') {
							details.contentType = 'image/jpeg';
						} else if (attachment.image.imageType == 'png') {
							details.contentType = 'image/png';
						}

						return {
							url: attachment.image.url,
							type: 'Photo',
							name: attachment.image.title,
							details,
							preview: attachment.image.thumbnail || attachment.image.url
						}
					} else if (attachment._type == 'link') {
						if (_.includes(attachment.link.url, `forms${env.suffix() == '' ? '-prod' : env.suffix()}-v2.k4connect.com`)) {
							return {
								url: attachment.link.url,
								type: 'Form',
								name: attachment.link.title,
								preview: attachment.link.thumbnail || null
							}
						} else {
							return {
								url: attachment.link.url,
								type: 'Web',
								name: attachment.link.title,
								details: { type: 'web' },
								preview: attachment.link.thumbnail || null
							}
						}
					} else if (attachment._type == 'video') {

						const details = {
							url: attachment.video.url, 
							type: 'video',
							title: attachment.video.title, 
							protocol: 'open-graph'
						}

						return {
							url: attachment.video.url,
							type: 'Web',
							name: attachment.video.title,
							details,
							preview: attachment.video.thumbnail || null
						}
					}
				});
			}

			posts.push({
				_id: post._id,
				title: post.title,
				body: post.body,
				author: post.author,
				startDate: post.published,
				assets
			});
		}

		const sortedPosts = _.sortBy(posts, (post)=> -(new Date(post.startDate).getTime()));

		return {
			_type: 'FeedPayload',
			posts: sortedPosts,
			pageInfo: {
				cursor: JSON.stringify(data),
				hasNextPage,
				currentPage: null
			}
		}

		// const posts = await papi.content.post.get()
		// const response = await this.query({
		// 	query: WhatsNew,
		// 	variables: {
		// 		communityId,
		// 		filters: {
		// 			audiences,
		// 			status: 'Active',
		// 			from
		// 		},
		// 		page: {
		// 			after,
		// 			limit
		// 		}
		// 	}
		// })

		// return response.data.community.feed;
	},

	async getFeed(category, tags, after, limit = 50)
	{
		const posts = []
		let postTags = []
		let page = 0;
		if (!_.isNil(after)) {
			page = after + 1;
		}

		let hasNextPage;

		if (category == 'Notice') {

			// only show future notices
			const filter = { sent: { '$lte': new Date().toISOString() } }

			const broadcasts = await papi.message.broadcast.getMy({ 
				limit: limit + 1, 
				skip: page * limit, 
				populate: 'attachments:file,attachments:video,attachments:image,attachments:link',
				filter: JSON.stringify(filter),
				sort: '-sent'
			});

			hasNextPage = broadcasts.length > limit;
			if (broadcasts.length > limit) {
				broadcasts.pop(); // remove extra broadcast used to determine if another page exists
			}

			for (const broadcast of broadcasts) {
				const notice = {
					_id: broadcast._id,
					title: broadcast.body,
					body: null,
					category,
					author: broadcast.sender,
					startDate: broadcast.sent
				}

				// if both subject and body exist, use the subject as the legacy title and the body as the legacy body
				if (broadcast.subject) {
					notice.title = broadcast.subject;
					notice.body = broadcast.body;
				}

				let assets = [];
				if (_.isArray(broadcast.attachments) && broadcast.attachments.length > 0) {
					assets = _.map(broadcast.attachments, (attachment)=> {
						if (attachment._type == 'file') {
							
							return {
								url: attachment.file.url,
								type: 'Pdf',
								name: attachment.file.title,
								details: { fileType: attachment.file.fileType },
								preview: attachment.file.thumbnail || null
							}

						} else if (attachment._type == 'image') {

							const details = {}

							if (attachment.image.imageType == 'jpg') {
								details.contentType = 'image/jpeg';
							} else if (attachment.image.imageType == 'png') {
								details.contentType = 'image/png';
							}

							return {
								url: attachment.image.url,
								type: 'Photo',
								name: attachment.image.title,
								details,
								preview: attachment.image.thumbnail || attachment.image.url
							}
						} else if (attachment._type == 'link') {
							if (_.includes(attachment.link.url, `forms${env.suffix}-v2.k4connect.com`)) {
								return {
									url: attachment.link.url,
									type: 'Form',
									name: attachment.link.title,
									preview: attachment.link.thumbnail || null
								}
							} else {
								return {
									url: attachment.link.url,
									type: 'Web',
									name: attachment.link.title,
									details: { type: 'web' },
									preview: attachment.link.thumbnail || null
								}
							}

							
						} else if (attachment._type == 'video') {

							const details = {
								url: attachment.video.url, 
								type: 'video',
								title: attachment.video.title, 
								protocol: 'open-graph'
							}

							return {
								url: attachment.video.url,
								type: 'Web',
								name: attachment.video.title,
								details,
								preview: attachment.video.thumbnail || null
							}
						}
					});
				}

				notice.assets = assets;
				posts.push(notice);
			}

		} else {

			// Find the content group for the feed category, then find all the subgroups
			const categoryGroups = await papi.content.group.get({ filter: JSON.stringify({ name: _.toLower(category) }) });
			const categoryGroup = _.find(categoryGroups, (group)=> _.isNil(group.parent));

			if (!_.isNil(categoryGroup)) {
				const groups = await papi.content.group.get({ filter: JSON.stringify({ active: true }), parent: categoryGroup._id, sort: '_displayOrder,name' });
				postTags = _.chain(groups).map('name').uniq().value();

				const tag = _.find(groups, ['name', tags]);
				let filter = { published: { '$lte': new Date().toISOString() }, parent: tag?._id || categoryGroup._id, _status: 'published' }

				// get one more post than the limit to easily compute if another page exists
				const camelotPosts = await papi.content.post.getMy({ 
					limit: limit + 1, 
					skip: page * limit, 
					populate: 'group:parent.name,attachments:file,attachments:video,attachments:image,attachments:link',
					sort: '-published',
					filter: JSON.stringify(filter)
				});

				hasNextPage = camelotPosts.length > limit;
				if (camelotPosts.length > limit) {
					camelotPosts.pop(); // remove extra post used to determine if another page exists
				}

				for (const post of camelotPosts) {
					let assets = [];
					if (_.isArray(post.attachments) && post.attachments.length > 0) {
						assets = _.map(post.attachments, (attachment)=> {
							if (attachment._type == 'file') {
								return {
									url: attachment.file.url,
									type: 'Pdf',
									name: attachment.file.title,
									details: { fileType: attachment.file.fileType },
									preview: attachment.file.thumbnail || null
								}

							} else if (attachment._type == 'image') {

								const details = {}

								if (attachment.image.imageType == 'jpg') {
									details.contentType = 'image/jpeg';
								} else if (attachment.image.imageType == 'png') {
									details.contentType = 'image/png';
								}

								return {
									url: attachment.image.url,
									type: 'Photo',
									name: attachment.image.title,
									details,
									preview: attachment.image.thumbnail || attachment.image.url
								}
							} else if (attachment._type == 'link') {
								if (_.includes(attachment.link.url, `forms${env.suffix() == '' ? '-prod' : env.suffix()}-v2.k4connect.com`)) {
									return {
										url: attachment.link.url,
										type: 'Form',
										name: attachment.link.title,
										preview: attachment.link.thumbnail || null
									}
								} else {
									return {
										url: attachment.link.url,
										type: 'Web',
										name: attachment.link.title,
										details: { type: 'web' },
										preview: attachment.link.thumbnail || null
									}
								}
							} else if (attachment._type == 'video') {

								const details = {
									url: attachment.video.url, 
									type: 'video',
									title: attachment.video.title, 
									protocol: 'open-graph'
								}

								return {
									url: attachment.video.url,
									type: 'Web',
									name: attachment.video.title,
									details,
									preview: attachment.video.thumbnail || null
								}
							}
						});
					}

					posts.push({
						_id: post._id,
						title: post.title,
						body: post.body,
						category,
						author: post.author,
						startDate: post.published,
						assets
					});
				}
			}

		}

		const communityId = store.getters['user/communityId'];

		return {
			_id: communityId.toString(),
			feed: {
				_type: 'FeedPayload',
				posts,
				pageInfo: {
					cursor: page.toString(),
					hasNextPage,
					currentPage: null
				}
			},
			tags: postTags
		}

		// const communityId = store.getters['user/communityId'];
		// const audiences = store.getters['user/audiences'];

		// const response = await this.query({
		// 	query: Feeds,
		// 	variables: {
		// 		communityId,
		// 		tagsInput: {
		// 			category,
		// 			sort: 'TagAsc',
		// 			audiences,
		// 			onlyActiveTags: true
		// 		},
		// 		filters: {
		// 			tags,
		// 			audiences,
		// 			category,
		// 			status: 'Active'
		// 		},
		// 		page: {
		// 			after,
		// 			limit
		// 		}
		// 	}
		// })

		// return response.data.community;
	},

	async getFeedItem(id)
	{
		try {
			const post = await papi.content.post.getByIdMy(id, { populate: 'group:parent.name,attachments:file,attachments:video,attachments:image,attachments:link' });

			let assets = [];
			if (_.isArray(post.attachments) && post.attachments.length > 0) {
				assets = _.map(post.attachments, (attachment)=> {
					if (attachment._type == 'file' && attachment.file.fileType == 'pdf') {
						
						return {
							url: attachment.file.url,
							type: 'Pdf',
							name: attachment.file.title,
							details: {},
							preview: attachment.file.thumbnail || null
						}

					} else if (attachment._type == 'image') {

						const details = {}

						if (attachment.image.imageType == 'jpg') {
							details.contentType = 'image/jpeg';
						} else if (attachment.image.imageType == 'png') {
							details.contentType = 'image/png';
						}

						return {
							url: attachment.image.url,
							type: 'Photo',
							name: attachment.image.title,
							details,
							preview: attachment.image.thumbnail || attachment.image.url
						}
					} else if (attachment._type == 'link') {
						if (_.includes(attachment.link.url, `forms`) && _.includes(attachment.link.url, `.k4connect.com`)) {
							return {
								url: attachment.link.url,
								type: 'Form',
								name: attachment.link.title,
								preview: attachment.link.thumbnail || null
							}
						} else {
							return {
								url: attachment.link.url,
								type: 'Web',
								name: attachment.link.title,
								details: { type: 'web' },
								preview: attachment.link.thumbnail || null
							}
						}
					} else if (attachment._type == 'video') {

						const details = {
							url: attachment.video.url, 
							type: 'video',
							title: attachment.video.title, 
							protocol: 'open-graph'
						}

						return {
							url: attachment.video.url,
							type: 'Web',
							name: attachment.video.title,
							details,
							preview: attachment.video.thumbnail || null
						}
					}
				});
			}

			const categoryGroup = _.filter(post.group, (group)=> _.isNil(group.parent));
			const category = categoryGroup[0]?.name

			return {
				_id: post._id,
				title: post.title,
				body: post.body,
				category,
				author: post.author,
				startDate: post.published,
				assets
			}
			

		} catch (e) {
			//post not found
			console.log(e);
		}

		try {
			// if 404 is received, check if the item is a message broadcast

			const notice = await papi.message.broadcast.getMyById(id, { populate: 'attachments:file,attachments:video,attachments:image,attachments:link' });

			let assets = [];
			if (_.isArray(notice.attachments) && notice.attachments.length > 0) {
				assets = _.map(notice.attachments, (attachment)=> {
					if (attachment._type == 'file' && attachment.file.fileType == 'pdf') {
						
						return {
							url: attachment.file.url,
							type: 'Pdf',
							name: attachment.file.title,
							details: {},
							preview: attachment.file.thumbnail
						}

					} else if (attachment._type == 'image') {

						const details = {}

						if (attachment.image.imageType == 'jpg') {
							details.contentType = 'image/jpeg';
						} else if (attachment.image.imageType == 'png') {
							details.contentType = 'image/png';
						}

						return {
							url: attachment.image.url,
							type: 'Photo',
							name: attachment.image.title,
							details,
							preview: attachment.image.thumbnail
						}
					} else if (attachment._type == 'link') {
						return {
							url: attachment.link.url,
							type: 'Web',
							name: attachment.link.title,
							details: { type: 'web' },
							preview: attachment.link.thumbnail || null
						}
					} else if (attachment._type == 'video') {

						const details = {
							url: attachment.video.url, 
							type: 'video',
							title: attachment.video.title, 
							protocol: 'open-graph'
						}

						return {
							url: attachment.video.url,
							type: 'Web',
							name: attachment.video.title,
							details,
							preview: attachment.video.thumbnail || null
						}
					}
				});

				return {
					_id: notice._id,
					title: notice.subject || notice.body,
					body: notice.subject ? notice.body : null,
					category: 'Notice',
					author: notice.sender,
					startDate: notice.sent,
					assets
				}
			}
		} catch(e) {
			//notice not found
			console.log(e);
		}


		// //TODO - papi top level requests, mock for now
		// if(id === '6b9f2e45-5b3d-4c74-9edd-39510cae78e4')
		// {
		// 	return _.find(MOCK_REQUESTS.feed.posts, [ '_id', '6b9f2e45-5b3d-4c74-9edd-39510cae78e4'])
		// }

		// const communityId = store.getters['user/communityId'];

		// const response = await this.query({
		// 	query: FeedItem,
		// 	variables: {
		// 		communityId,
		// 		id
		// 	}
		// })

		// return response.data.community.feedItem;
	},

	async submitForm(id, values)
	{

		const communityId = store.getters['user/communityId'];
		const userId = store.getters['user/id'];

		const response = await http.post(`https://forms${env.suffix() == '' ? '-prod' : env.suffix()}-v2.k4connect.com/submissions`, {
			formId: id,
			data: JSON.stringify(values), 
			communityId, 
			userId
		}, {
			headers: {
				authorization: `Bearer ${this.jwt}`
			}
		});

		return {
			id: response.id,
			createdAt: response.createdAt,
			status: response.status
		}

		// return this.mutate({
		// 	mutation: SubmitForm,
		// 	variables: {
		// 		formId: id,
		// 		data: JSON.stringify(values),
		// 		communityId,
		// 		userId
		// 	}
		// });

	},



	//dining

	async getRestaurants(first = 50)
	{
		const restaurants = await papi.dining.restaurant.getMy({ select: '_id,name', limit: first, sort: '_displayOrder' });
		return restaurants;
	},

	async getMenus(restaurantId, first = 50)
	{

		const menus = await papi.dining.menu.getMy({ 
			restaurant: restaurantId, 
			select: '_id,name,_startDate,_endDate,availability',
			limit: first, 
			sort: '_displayOrder'
		});

		const filtered = _.filter(menus, (menu)=> {

			const current = DateTime.local();

			if (menu._startDate) {
				const start = DateTime.fromFormat(menu._startDate, 'yyyy-MM-dd');
				
				if (start > current) return false; // menu isn't available yet
				if (menu._endDate) {
					const end = DateTime.fromFormat(menu._endDate, 'yyyy-MM-dd');
					return end > current; // filter out menus that are no longer available
				} else {
					return true; // menu is already available and doesn't have an end date
				}

			} else {
				return true;
			}

		});

		// filter out menus that aren't available today. computeAvailability ORs a menu's
		// availability rules, but only against the one timestamp it is given, and each rule
		// carries its own time window — so try the start time of each rule in turn and keep
		// the menu if it is available at any of them.
		const available = _.filter(filtered, (menu)=> {

			if (!menu.availability || menu.availability.length === 0) return true; // no restrictions on the menu availability, always available

			return _.some(menu.availability, (availability)=> {

				const menuStart = new Date();

				// test inside the rule's own window rather than at the current time, the same
				// way item availability is tested at the meal/item intersection — otherwise a
				// menu whose window hasn't opened yet (or already closed) today would be
				// filtered out even though it belongs on today's menu. A rule without a start
				// time has no time restriction, so midnight is safe.
				const [menuHour, menuMinute, menuSeconds] = (availability.start || '00:00:00').split(':');
				menuStart.setHours(menuHour);
				menuStart.setMinutes(menuMinute);
				menuStart.setSeconds(menuSeconds);

				return computeAvailability([menu], 'availability', menuStart).length > 0;
			});

		});

		return available;

		// const communityId = store.getters['user/communityId'];
		// const audiences = store.getters['user/audiences'];

		// const menus = await papi.dining.menu.get();
		// console.log(menus)

		// const response = await this.query({
		// 	query: Menus,
		// 	variables: {
		// 		communityId,
		// 		restaurantId,
		// 		first,
		// 		audiences
		// 	}
		// })
		
		// const { edges } = response.data.community.restaurant.availableMenusForThisWeek;
		// return _.map(edges, (item) => ({...item.node}));
	},

	async getMenu(restaurantId, menuId, date, first = 50, timeframe = 'Day')
	{
		// const communityId = store.getters['user/communityId'];
		// const audiences = store.getters['user/audiences'];

		const menu = await papi.dining.menu.getByIdMy(menuId, { restaurant: restaurantId, populate: 'items:category,items:meal,restaurant' });
		const sections = [];

		if (_.isArray(menu.items) && menu.items.length > 0) {
			
			// get all of the meals from the items, sort by display order then start time
			const meals = _.chain(menu.items).flatMap('meal').uniqBy('_id').sortBy(['displayOrder', 'availability[0].start']).value();

			for (const meal of meals) {

				// meal is available all day (no restrictions) if no availability is set
				const mealStartTime = _.get(meal, 'availability[0].start', '00:00:00');
				const mealEndTime = _.get(meal, 'availability[0].end', '23:59:59');

				const mealStart = new Date(date);

				const [mealHour, mealMinute, mealSeconds] = mealStartTime.split(':');
				mealStart.setHours(mealHour);
				mealStart.setMinutes(mealMinute);
				mealStart.setSeconds(mealSeconds);

				// scope context for the availability engine: the menu being viewed and the
				// current meal. Items/meals whose availability is scoped to a specific menu
				// or meal only resolve when that context is supplied; unscoped items pass
				// regardless, and extra context types a rule doesn't restrict are ignored.
				const scope = [
					{ type: 'diningMenu', values: _.compact([menuId]) },
					{ type: 'diningMeal', values: _.compact([meal._id]) }
				];

				const mealAvailability = computeAvailability([meal], 'availability', mealStart, scope);
				if (mealAvailability.length === 0) continue;

				// filter items that belong to this meal
				const itemsForMeal = _.filter(menu.items, (item)=> item.meal.findIndex((itemMeal)=> itemMeal._id == meal._id) > -1);

				// check availability at intersection of meal and item times
				const mealItems = _.filter(itemsForMeal, (item)=> {
					if (!item.availability || item.availability.length === 0) return true; // no restrictions on the item availability, always available

					// check intersections for all of the availabilities
					return _.some(item.availability, (availability)=> {
	
						// check if the availability timeframe overlaps the meal timeframe

						// case 1: one timeframe completely contains the other (or the timeframes are equal)
						const case1 = (availability.start >= mealStartTime && availability.end <= mealEndTime) || (mealStartTime >= availability.start && mealEndTime <= availability.end);

						// case 2: availability end is between start & end
						const case2 = availability.end > mealStartTime && availability.end <= mealEndTime;

						// case 3: availability start is between start & end
						const case3 = availability.start >= mealStartTime && availability.start < mealEndTime;


						// if the availability doesn't overlap with the meal at all, skip
						if (!(case1 || case2 || case3)) return false;

						const itemStart = new Date(date);
						// find the later start time between meal and item to check availability at their intersection
						const [itemHour, itemMinute, itemSeconds] = availability.start.split(':');
						itemStart.setHours(itemHour);
						itemStart.setMinutes(itemMinute);
						itemStart.setSeconds(itemSeconds);

						const intersectionTime = mealStart.getTime() > itemStart.getTime() ? mealStart : itemStart;

						let itemAvailability = [item];

						const fields = [
							'category.availability',
							'availability',
							'meal.availability'
						]

						
						_.each(fields, (field)=> {
							itemAvailability = computeAvailability(itemAvailability, field, intersectionTime, scope);
						});

						return itemAvailability.length > 0;
					});
				});

				// get the categories for those items
				const categories = _.chain(mealItems).map((item)=> {
					if (item.category) {
						return {
							_id: item.category?._id,
							name: item.category?.name,
							displayOrder: item.category?.displayOrder
						}
					}
				}).compact().uniqBy('name').sortBy('displayOrder').value();

				// get any items for the meal that don't have a category
				const emptyCategoryItems = _.filter(mealItems, (i)=> _.isNil(i.category));
				if (emptyCategoryItems.length > 0) {
					// check if the "Other" category is already in the categories list, add it if not
					if (!_.find(categories, (c)=> c.name == 'Other')) {
						categories.push({
							_id: utils.getDiningCategoryGuid(menu._communityId, 'other'),
							name: 'Other'
						});
					}
				}

				const availableMenuItemsByCategory = _.map(categories, (category)=> {
					const mapped = {
						category: { _id: category._id, name: category.name }
					}
					let items = _.filter(mealItems, (item)=> item.category?.name === category.name);

					if (category.name == 'Other' && emptyCategoryItems.length > 0) {
						// add any available items that don't have a category to the "Other" category
						items.push(...emptyCategoryItems);
					}

					items = _.uniqBy(items, '_id');
					items = _.sortBy(items, 'displayOrder');
					mapped.menuItems = _.map(items, (item)=> {

						let nutritionInfo = [];
						
						if (!_.isNil(item.nutrition)) {
							nutritionInfo = _.map(_.keys(item.nutrition), (key)=> {
				
								let value = item.nutrition[key];
								// round to 2 decimal points to prevent any weirdness with node floating point issues
								if (_.isNumber(value) && !_.isInteger(value)) {
									value = value.toFixed(2);
								}

								return {
									name: _.startCase(key),
									value
								}
							});
						}

						const attributes = [];
						if (item.allergens && item.allergens.length > 0) {
							for (const allergen of item.allergens) {
								attributes.push({
									type: 'allergy',
									value: _.startCase(allergen)
								});
							}
						}

						if (item.ingredients && item.ingredients.length > 0) {
							for (const ingredient of item.ingredients) {
								attributes.push({
									type: 'ingredient',
									value: _.startCase(ingredient)
								});
							}
						}
						
						return {
							_id: item._id,
							name: item.name,
							description: item.description,
							nutritionInfo,
							attributes
						}
					});

					return mapped;
				});

				sections.push({
					name: meal.name,
					availableMenuItemsByCategory
				});
				
			}
		}

		let startDate = menu._startDate;
		let endDate = menu._endDate;

		const dateObj = DateTime.fromISO(date);
		if (_.isNil(startDate) && _.isNil(endDate)) {
			startDate = dateObj.startOf('day').minus({ days: 1 }).toISO();
			endDate = dateObj.endOf('day').plus({ days: 1 }).toISO();
		} else if (_.isNil(startDate)) {
			startDate = dateObj.startOf('day').minus({ days: 1 }).toISO();
		} else if (_.isNil(endDate)) {
			endDate = dateObj.endOf('day').plus({ days: 1 }).toISO();
		}

		return {
			name: menu.name,
			availability: {
				startDate,
				endDate
			},
			sections
		}


		// const response = await this.query({
		// 	query: Menu,
		// 	variables: {
		// 		communityId,
		// 		restaurantId,
		// 		menuId,
		// 		date,
		// 		timeframe,
		// 		first,
		// 		audiences
		// 	}
		// })
		// return response.data.community.restaurant.menu;
	},


	//directory

	async getDirectory(communityId)
	{
		const users = await papi.census.user.get({ 
			select: '_id,_type,groups,firstName,lastName,preferredName,location,_optOutOfDirectoryFields,biography,email,birthdate,phone,mobile,staff,resident,family,photo',
			_optOutOfDirectory: false,
			status: 'active'
		});

		const _communityId = utils.idToGuid(communityId, 'association');

		let alexaPhonebook, phonebookRooms;

		const details = await papi.services.my.details();
		if (details.user._type == 'resident' && details.systems && details.systems.length > 0) {
			alexaPhonebook = await papi.services.my.alexaPhoneBookList();
			phonebookRooms = _.map(alexaPhonebook.associatedRooms, 'room');
		}
		const groups = details.user.groups;

		let lifecircles;
		if (groups) {
			lifecircles = _.filter(groups, (group)=> group._type == 'lifecircle' && group._communityId == _communityId);
			lifecircles = _.map(lifecircles, '_id');
		}

		let familyIds = [];
		let residentUsers = users;

		if (lifecircles && lifecircles.length > 0) {
			familyIds = _.filter(users, (user)=> _.intersection(user.groups, lifecircles).length > 0);
			familyIds = _.map(familyIds, (user)=> user._id);

			if (details.user._type == 'family') {
				// if the current user is a family member, the residents tab should only show residents in the user's lifecircle
				residentUsers = _.filter(residentUsers, (user)=> _.includes(familyIds, user._id));
			}
		}

		const residents = _.filter(residentUsers, (user)=> user._type == 'resident' && user.resident);
		const mapped = []
		
		for (const user of residents) {

			const { _id, firstName, preferredName, lastName, email, mobile, phone, photo, location, birthdate, _optOutOfDirectory, _optOutOfDirectoryFields, resident } = user;

			const words = _.words(resident.careSetting);
			let careSetting;
			if (words.length > 1) {
				careSetting = `${_.capitalize(words[0])} ${words[1]}`
			} else {
				careSetting = _.capitalize(words[0]);
			}

			let hasAlexaDevice = false;

			if (details.user._type == 'resident' && details.systems && details.systems.length > 0) {
				hasAlexaDevice = _.some(alexaPhonebook.associatedRooms, (room)=> {
					return !_.isNil(room.users) && _.includes(room.users, _id);
				});

				// if no phonebook rooms match the location name and the id is the current user's id, check for the user's systems in the phonebook
				if (_id == details.user._id && !hasAlexaDevice) {
					const systemIds = _.map(details.systems, '_id');
					const rooms = _.filter(phonebookRooms, (room)=> _.includes(systemIds, room.systemId));
					hasAlexaDevice = rooms.length > 0;
				}
			}
			

			mapped.push({
				_id,
				_type: 'Resident',
				family: _.includes(familyIds, _id),
				firstName: preferredName || firstName,
				lastName,
				fullName: `${preferredName || firstName} ${lastName}`,
				email: _optOutOfDirectoryFields?.includes('email') ? null : email,
				primaryPhone: _optOutOfDirectoryFields?.includes('phone') ? null : phone || mobile || null,
				profileImage: photo,
				thumbnail: photo,
				address: location?.name, // papi maps the sso roomNumber property to 'address' before returning query results
				building: location?.building || null,
				birthdate: _optOutOfDirectoryFields?.includes('birthdate') ? null : birthdate,
				optOutOfDirectory: false,
				careSetting,
				hasAlexaDevice
			})
		}

		const family = _.filter(users, (user)=> _.includes(familyIds, user._id) && user._type == 'family');
		for (const user of family) {
			const { _id, firstName, preferredName, lastName, email, mobile, phone, photo, location, birthdate, _optOutOfDirectory, _optOutOfDirectoryFields } = user;

			const relationshipMap = {
				'spouse': 'Spouse',
				'sibling': 'Sibling',
				'son': 'Son',
				'daughter': 'Daughter',
				'grandson': 'Grandson',
				'granddaughter': 'Granddaughter',
				'friend': 'Friend',
				'otherFamily': 'Other',
				'inLaws': 'In_Laws'
			}

			mapped.push({
				_id,
				_type: 'Contact',
				family: true,
				firstName: preferredName || firstName,
				lastName,
				fullName: `${preferredName || firstName} ${lastName}`,
				email: _optOutOfDirectoryFields?.includes('email') ? null : email,
				primaryPhone: _optOutOfDirectoryFields?.includes('phone') ? null : phone || mobile || null,
				profileImage: photo,
				thumbnail: photo,
				address: location?.name, // papi maps the sso roomNumber property to 'address' before returning query results
				building: location?.building || null,
				birthdate: _optOutOfDirectoryFields?.includes('birthdate') ? null : birthdate,
				optOutOfDirectory: false,
				relationship: relationshipMap[user.family.relationship]
			})
		}

		// find the current user's info
		const directory = _.remove(mapped, (user)=> user._id == details.user._id);
		const sortedResidents = _.sortBy(mapped, ['lastName', 'firstName']);

		directory.push(...sortedResidents)

		// papi filters out staff with hidden profiles, so it needs to be done here 
		const staff = _.filter(users, (user)=> user._type == 'staff' && user.staff && !(user._optOutOfDirectory));
		const sortedStaff = _.sortBy(staff, ['lastName', 'firstName']);
		const staffDirectory = _.map(sortedStaff, (user)=> {
			const { _id, firstName, preferredName, lastName, email, phone, mobile, biography, photo, _optOutOfDirectory, _optOutOfDirectoryFields, staff } = user;
			return {
				_id, 
				firstName: preferredName || firstName,
				lastName, 
				fullName: `${preferredName || firstName} ${lastName}`,
				email: _optOutOfDirectoryFields?.includes('email') ? null : email, 
				primaryPhone: _optOutOfDirectoryFields?.includes('phone') ? null : phone || mobile || null,
				biography: biography?.short || null,
				profileImage: photo,
				jobTitle: staff.title,
				department: staff.department,
				optOutOfDirectory: false,
				_type: 'Staff'
			}
		});

		return {
			directory,
			staffDirectory
		}

		// const response = await this.query({
		// 	query: DirectoryList,
		// 	variables: {
		// 		communityId
		// 	}
		// })

		// return response.data.me.community;
	},

	async getDetails(id)
	{
		const currentUser = store.getters['user/id'];

		// get the current user's lifecircles for determining if another user is family
		const details = await papi.services.my.details();
		let lifecircles = _.filter(details.user.groups, (group)=> group._type == 'lifecircle' && group._communityId == utils.idToGuid(store.getters['user/communityId'], 'association'));
		lifecircles = _.map(lifecircles, '_id');

		const user = await papi.census.user.getById(id);
		const { _id, email, firstName, lastName, preferredName, photo, biography, _type, phone, mobile, groups, _optOutOfDirectory } = user;

		const userObject = {
			_type: _.startCase(_type),
			_id, email, lastName,
			firstName: preferredName || firstName,
			fullName: `${ preferredName || firstName } ${lastName}`,
			family: _.intersection(groups, lifecircles).length > 0,
			biography: biography?.short,
			profileImage: photo,
			primaryPhone: phone,
			secondaryPhone: mobile,
			optOutOfDirectory: _optOutOfDirectory
		}

		let alexaPhonebook;

		if (details.user._type == 'resident' && details.systems && details.systems.length > 0) {
			alexaPhonebook = await papi.services.my.alexaPhoneBookList();
		}

		if (_type == 'resident') {
			userObject.address = user.location?.name;
			userObject.building = user.location?.building || null;
			userObject.phoneNumber = phone;
			userObject.birthdate = user.birthdate;
			userObject.careSetting = user.resident.careSetting;

			if (_id == currentUser) {
				// use system names since they are available
				userObject.rooms = _.map(details.systems, (system)=> {
					return { name: system._name }
				});
			} else {
				if (alexaPhonebook) {
					const filtered = _.filter(alexaPhonebook.associatedRooms, (r)=> !_.isNil(r.users) && _.includes(r.users, id));
					userObject.rooms = _.map(filtered, (r)=> {
						return { name: r.room }
					});
				} else {
					userObject.rooms = []
				}
				
			}

			const hiddenFields = [];
			for (const field of user._optOutOfDirectoryFields) {
				switch (field) {
					case 'email':
						hiddenFields.push('email');
						break;
					case 'phone':
						hiddenFields.push('primaryPhone');
						break;
					case 'mobile':
						hiddenFields.push('secondaryPhone');
						break;
					case 'birthdate':
						hiddenFields.push('birthdate');
						break;
				}
			}
		
			if (details.user._type == 'resident' && details.systems && details.systems.length > 0) {
				userObject.hasAlexaDevice = _.some(alexaPhonebook.associatedRooms, (r)=> {
					return !_.isNil(r.users) && _.includes(r.users, id);
				});
			} else {
				userObject.hasAlexaDevice = false;
			}

			userObject.hiddenFields = hiddenFields;
			
		} else if (_type == 'staff') {

			userObject.jobTitle = user.staff.title;
			userObject.department = user.staff.department;
		} else if (_type == 'family') {
			const relationshipMap = {
				'spouse': 'Spouse',
				'sibling': 'Sibling',
				'son': 'Son',
				'daughter': 'Daughter',
				'grandson': 'Grandson',
				'granddaughter': 'Granddaughter',
				'friend': 'Friend',
				'otherFamily': 'Other',
				'inLaws': 'In_Laws'
			}
			userObject.relationship = relationshipMap[user.family.relationship]
			userObject._type = 'Contact';
		}

		// remove fields another user has opted out of
		if (id != currentUser) {
			if(_.includes(user._optOutOfDirectoryFields, 'email'))  userObject.email = null;
			if(_.includes(user._optOutOfDirectoryFields, 'phone'))  userObject.primaryPhone = null;
			if(_.includes(user._optOutOfDirectoryFields, 'mobile'))  userObject.secondaryPhone = null;
			if(_.includes(user._optOutOfDirectoryFields, 'birthdate'))  userObject.birthdate = null;
		}

		return userObject;
	},

	async searchDirectory(communityId, query, roles)
	{
		// const response = await this.query({
		// 	query: DirectorySearch,
		// 	variables: {
		// 		communityId,
		// 		query,
		// 		roles
		// 	}
		// })

		// return response.data.me.community.search.users;
	},

	async alexaAddressBook() {

		if (store.getters['user/isResident']) {
			const { alexaAddressBook } = await papi.services.my.alexaContactsList();
		
			const contacts = _.get(alexaAddressBook, 'contacts');

			if (_.isNil(contacts) || _.isEmpty(contacts)) return alexaAddressBook;

			// components expect the phoneNumbers field for contacts to be an array of strings
			for (const contact of contacts) {
				if (contact.phoneNumbers && contact.phoneNumbers.length > 0) {
					contact.phoneNumbers = _.map(contact.phoneNumbers, 'number');
				}
			}

			return alexaAddressBook;
		} else {
			return null;
		}

		
		// const response = await this.query({
		// 	query: AlexaAddressBook
		// })

		// return response.data.me.alexaAddressBook;
	},

	async addAlexaContact({ roomName, phoneNumber, contactName } = {}) {

		if (store.getters['user/isResident']) {
			await papi.services.my.alexaContactsAdd({ roomName, phoneNumber, contactName });
		}
		// const communityId = store.getters["user/communityId"];

		// return this.mutate({
		// 	mutation: AddAlexaContact,
		// 	variables: {
		// 		communityId,
		// 		input: {
		// 			roomName,
		// 			contacts: [{
		// 				type: "pstn",
		// 				phoneNumbers: [phoneNumber],
		// 				name: contactName,
		// 			}],
		// 		},
		// 	},
		// });
	},

	async removeAlexaContact({ roomName, contactName } = {}) {

		if (store.getters['user/isResident']) {
			await papi.services.my.alexaContactsRemove({ roomName, contactName });
		}

		// const communityId = store.getters["user/communityId"];
		// return this.mutate({
		// 	mutation: RemoveAlexaContact,
		// 	variables: {
		// 		communityId,
		// 		input: { roomName, contactName },
		// 	},
		// });
	},

	//events

	async getEvents(page, limit, timeframe, price, calendars, search)
	{
		// determine the 'from' and 'to' query dates for camelot
		const startDate = DateTime.now();
		const startOfDay = startDate.startOf('day');
		let endDate;
	
		switch (timeframe) {
			case 'Year': // only load 90 days out to prevent memory issues 
				endDate = startOfDay.plus({ days: 90 });
				break;
			case 'Month':
				endDate = startOfDay.endOf('month');
				break;
			case 'Week': 
				// add 1 day to startOfDay in case startOfDay is a Sunday, since luxon uses week start = monday
				endDate = startOfDay.plus({ days: 1 }).endOf('week').minus({ days: 1 }).endOf('day'); // start of week sunday
				break;
			case 'Day':
				endDate = startOfDay.endOf('day');
				break;
		}

		// get community calendars and signups within the time frame
		// signups should not use /my/events/signup, since this will only return the user's signups
		const signupData = await papi.events.signup.get({
			filter: JSON.stringify({ start: { '$gte': startOfDay.toISO(), '$lte': endDate.toISO() }}),
			populate: 'user,guests:resident:user'
		});

		// get unique event IDs from signups and fetch events without _ics
		const eventIds = _.uniq(_.map(signupData, 'event'));
		const eventsWithoutIcs = eventIds.length > 0 ? await papi.events.event.get({
			filter: JSON.stringify({ _id: { '$in': eventIds } }),
			select: '-_ics'
		}) : [];

		// create a map for quick event lookup
		const eventMap = _.keyBy(eventsWithoutIcs, '_id');

		// map events back to signups
		signupData.forEach(signup => {
			signup.event = eventMap[signup.event] || signup.event;
		});

		const calendarData = await papi.events.calendar.getMy({ select: 'name,_id', sort: '_displayOrder' });


		// build query params for events call
		// limit is not included since pagination needs to be based on the event occurrences
		const params = {
			from: startOfDay.toISO(),
			to: endDate.toISO(),
			populate: '_location,calendar,_otherCalendars',
		}

		const filter = {
			_status: 'published'
		}

		if (price == 'costs') {
			params['registration._paymentRequired'] = true;
		} else if (price == 'free') {
			params['registration._paymentRequired'] = false;
		}

		if (calendars && calendars.length > 0) {
			// filter.calendar = calendars;
			filter.calendar = { '$in': calendars };
		}

		if (search) {
			const searchRegEx = new RegExp(`${search}`, 'i')
			filter.name = searchRegEx.toString();
		}

		params.filter = JSON.stringify(filter);

		const events = await papi.events.event.getMy(params);

		const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

		// expand events using ui library
		let occurrences = [];
		const runExpand = async () => {
			occurrences = [];
			for (const event of events) {
				const dates = await expand(event, startOfDay.toJSDate(), endDate.toJSDate(), timezone);
				for (const date of dates) {
					occurrences.push({ eventId: date.id, start: date.start, end: date.end, location: date.location, name: date.title });
				}
			}
		};
		try {
			await runExpand();
		} catch (e) {
			const msg = e?.message || '';
			if (msg.includes('detached') || msg.includes('out-of-bounds')) {
				await runExpand();
			} else {
				throw e;
			}
		}

		// filter events, keeping future events and any that have started but not ended
		occurrences = _.filter(occurrences, (occurrence)=> {
			const end = parseDateFromRRule(occurrence.end);
			return end > startDate
		});

		// sort the instances by start date for pagination
		occurrences = _.sortBy(occurrences, ['start', 'name']);

		let occurrencesToMap = _.drop(occurrences, page * limit); // skip to the start of the page
		occurrencesToMap = _.take(occurrencesToMap, limit + 1); // take one more than needed to easily tell if another page exists

		const mapped = [];
		for (const item of occurrencesToMap) {

			const event = _.find(events, (event)=> event._id == item.eventId);

			const { _id } = event;

			const occurrence = _.pick(event, ['name', 'description', 'registration', 'virtual', 'allDay', 'calendar', '_location', '_otherCalendars']);

			occurrence.start = parseDateFromRRule(item.start).toISOString();
			occurrence.end = parseDateFromRRule(item.end).toISOString();
			
			if (_.find(event.additionalOccurrences, ['start', occurrence.start])) {
				const details = _.find(event.additionalOccurrences, ['start', occurrence.start]);
				if (details.end != details.start) {
					occurrence.end = details.end
				} else {
					const duration = new Date(event.end).getTime() - new Date(event.start).getTime();
					const startDate = new Date(occurrence.start);
					occurrence.end = new Date(startDate.getTime() + duration).toISOString()
				}
	
				if (details.name) occurrence.name = details.name;
				if (details.description) occurrence.description = details.description;
	
	
				if (details.location && !_.isEmpty(details.location)) {
					occurrence._location = { _name: details.location.name };
				}
	
				if (details.registration && !_.isEmpty(details.registration)) {
					occurrence.registration = _.merge({}, event.registration, details.registration);
				}
	
				if (details.virtual && !_.isEmpty(details.virtual)) {
					occurrence.virtual = _.merge({}, event.virtual, details.virtual);
				}
	
				if (!_.isNil(details.allDay)) {
					occurrence.allDay = details.allDay;
				}
	
				if (details.cost && !_.isEmpty(details.cost)) {
					occurrence.cost = _.merge({}, event.cost, details.cost);
				}

				occurrence._id = utils.getInstanceIdByEventIdAndStart(_id, occurrence.start);

			} else if (occurrence.start !== event.start) {
				occurrence._id = utils.getInstanceIdByEventIdAndStart(_id, occurrence.start);
			} else {
				occurrence._id = event._id; // use the actual event id if the event isn't recurring
			}

			// map calendars
			const camelotCalendars = [occurrence.calendar, ...occurrence._otherCalendars];
			const calendars = _.map(camelotCalendars, (calendar)=> {
				if (calendar.audience && calendar.audience.careSettingFilter && calendar.audience.careSettingFilter.length > 0) {
					return {
						careSettings: _.map(calendar.audience.careSettingFilter, (careSetting)=> {
							const words = _.words(careSetting);
							if (words.length > 1) {
								return { name: `${_.capitalize(words[0])} ${words[1]}`}
							} else {
								return { name: _.capitalize(words[0])}
							}
						})
					}
				} else {
					return {
						careSettings: [
							{ name: 'Independent' },
							{ name: 'Skilled Nursing' },
							{ name: 'Assisted' },
							{ name: 'Home' },
							{ name: 'Memory Care' }
						]
					}
				}
			});


			const { registration } = occurrence;

			// map signups
			const signups = _.filter(signupData, (signup)=> signup.event._id == event._id && signup.start == occurrence.start);
			let rsvps = []

			if (signups && signups.length > 0) {
				rsvps = _.flatMapDeep(signups, (signup)=> {
					let guests = []
					if (signup.guests && signup.guests.length > 0) {
						guests = _.map(signup.guests, (guest)=> {
							if (guest._type == 'nonResident') {
								return {
									_id: signup._id, 
									status: _.isNil(registration.capacity) ? 'Registered' : signup._displayOrder < registration.capacity ? 'Registered' : 'Waitlisted',
									comments: null,
									user: {
										fullName: `${signup.user.preferredName || signup.user.firstName} ${signup.user.lastName}`,
										_id: signup.user._id
									},
									guestName: guest.nonResident?.name ?? strings.events.guestLabel,
									__typename: 'GuestRSVP'
								}
							} else {
								return {
									_id: signup._id, 
									status: _.isNil(registration.capacity) ? 'Registered' : signup._displayOrder < registration.capacity ? 'Registered' : 'Waitlisted',
									comments: null,
									user: {
										_id: guest?.resident?.user?._id
									}
								}
							}
						})
					}
	
					const user = {
						_id: signup.user._id,
						firstName: signup.user.preferredName || signup.user.firstName, 
						lastName: signup.user.lastName,
						fullName: `${signup.user.preferredName || signup.user.firstName} ${signup.user.lastName}`
					}
	
					if (signup.user._type == 'resident') {
						user.optOutOfDirectory = signup.user._optOutOfDirectory;
					}
	
					const mapped =  {
						_id: signup._id, 
						status: _.isNil(registration.capacity) ? 'Registered' : signup._displayOrder < registration.capacity ? 'Registered' : 'Waitlisted',
						comments: signup.comments || null,
						user,
						__typename: 'UserRSVP'
					}
	
					return [mapped, guests]
				});
			}

			// map virtualEventDestinations & urlDetails
			let urlDetails = {};
			let virtualEventDestinations = [];
			if (_.get(occurrence, 'virtual._slideshow')) {

				const slideshow = occurrence.virtual._slideshow;

				// map virtual destinations
				if (slideshow.destination && slideshow.destination.length > 0) {
					virtualEventDestinations = _.map(slideshow.destination, (dest)=> {
						return { _id: dest._id, name: dest.name }
					});
				}

				// map link and video slides
				const videos = _.filter(slideshow.slides, ['_type', 'video']);
				const links = _.filter(slideshow.slides, ['_type', 'link']);

				if (videos && videos.length > 0) {
					urlDetails = {
						type: 'video',
						provider: videos[0].video.provider,
						title: videos[0].video.title,
						previewImage: videos[0].video.thumbnail
					}
				} else if (links && links.length > 0) {
					urlDetails = {
						type: 'web',
						title: links[0].link.title,
						previewImage: links[0].link.thumbnail
					}
				}
			}


			const { name, description, start, end, allDay } = occurrence;

			mapped.push({
				_id: occurrence._id,
				name,
				openSpots: registration.capacity ? Math.max(registration.capacity - rsvps.length, 0) : null,
				totalSpots: registration.capacity,
				location: item.location, // events.js returns the event location name 
				startsAt: start, 
				endsAt: end,
				costsMoney: !!(registration._paymentRequired),
				allDay,
				description, 
				url: _.get(occurrence, 'virtual.url') || null,
				urlDetails,
				commentPrompt: registration._commentPrompt || null,
				signupUrl: registration.url || null,
				rsvps,
				virtualEventDestinations,
				calendars
			});
		}

		const hasNextPage = mapped.length > limit;
		if (hasNextPage) mapped.pop(); // remove the one extra event instance if present

		return {
			eventInstances: {
				events: mapped,
				pageInfo: {
					currentPage: page,
					hasNextPage
				}
			},
			eventCalendars: calendarData
		}

	},


	async getEvent(eventId)
	{
		const { eventId: searchStr, start: instanceStart } = utils.getEventIdAndStartByInstanceId(eventId);

		// get the event
		const parentEvent = await papi.events.event.getMy({
			_id: new RegExp(`^${searchStr.substring(0, searchStr.length - 8)}`).toString(),
			populate: '_location,calendar,_otherCalendars,virtual:_slideshow:destination,virtual:_slideshow:slides:link,virtual:_slideshow:slides:video'
		});

		const event = parentEvent[0];
		const occurrence = _.pick(event, ['name', 'description', 'registration', 'virtual', 'allDay', 'calendar', '_location', '_otherCalendars']);

		
		// eventId will equal event._id if the event is not recurring, use event.start in these cases
		occurrence.start = event._id == eventId ? event.start : instanceStart;

		if (_.find(event.additionalOccurrences, ['start', occurrence.start])) {
			const details = _.find(event.additionalOccurrences, ['start', occurrence.start]);
			if (details.end != details.start) {
				occurrence.end = details.end
			} else {
				const duration = new Date(event.end).getTime() - new Date(event.start).getTime();
				const startDate = new Date(occurrence.start);
				occurrence.end = new Date(startDate.getTime() + duration).toISOString()
			}

			if (details.name) occurrence.name = details.name;
			if (details.description) occurrence.description = details.description;


			if (details.location && !_.isEmpty(details.location)) {
				occurrence._location = { _name: details.location.name };
			}

			if (details.registration && !_.isEmpty(details.registration)) {
				occurrence.registration = _.merge({}, event.registration, details.registration);
			}

			if (details.virtual && !_.isEmpty(details.virtual)) {
				occurrence.virtual = _.merge({}, event.virtual, details.virtual);
			}

			if (!_.isNil(details.allDay)) {
				occurrence.allDay = details.allDay;
			}

			if (details.cost && !_.isEmpty(details.cost)) {
				occurrence.cost = _.merge({}, event.cost, details.cost);
			}
			
		} else if (occurrence.start == event.start) {
			// occurrence is first or only occurrence in series, so just use end from event
			occurrence.end = event.end;
		} else {
			// calculate end using the duration of first event in series
			const duration = new Date(event.end).getTime() - new Date(event.start).getTime();
			const startDate = new Date(occurrence.start);
			occurrence.end = new Date(startDate.getTime() + duration).toISOString()
		}

		// map calendars
		const camelotCalendars = [occurrence.calendar, ...occurrence._otherCalendars];
		const calendars = _.map(camelotCalendars, (calendar)=> {
			if (calendar.audience && calendar.audience.careSettingFilter && calendar.audience.careSettingFilter.length > 0) {
				return {
					_id: calendar._id,
					name: calendar.name,
					careSettings: _.map(calendar.audience.careSettingFilter, (careSetting)=> {
						const words = _.words(careSetting);
						if (words.length > 1) {
							return { name: `${_.capitalize(words[0])} ${words[1]}`}
						} else {
							return { name: _.capitalize(words[0])}
						}
					})
				}
			} else {
				return {
					_id: calendar._id,
					name: calendar.name,
					careSettings: [
						{ name: 'Independent' },
						{ name: 'Skilled Nursing' },
						{ name: 'Assisted' },
						{ name: 'Home' },
						{ name: 'Memory Care' }
					]
				}
			}
		});



		// map signups
		const { registration } = occurrence;

		const signups = await papi.events.signup.get({ 
			event: event._id, 
			start: occurrence.start,
			populate: 'user' 
		});
		let rsvps = []

		if (signups && signups.length > 0) {
			rsvps = _.flatMapDeep(signups, (signup)=> {
				let guests = []
				if (signup.guests && signup.guests.length > 0) {
					guests = _.map(signup.guests, (guest)=> {
						if (guest._type == 'nonResident') {
							return {
								_id: signup._id, 
								status: _.isNil(registration.capacity) ? 'Registered' : signup._displayOrder < registration.capacity ? 'Registered' : 'Waitlisted',
								comments: null,
								user: {
									fullName: `${signup.user.preferredName || signup.user.firstName} ${signup.user.lastName}`,
									_id:  signup.user._id
								},
								guestName: guest.nonResident?.name ?? strings.events.guestLabel,
								__typename: 'GuestRSVP'
							}
						} else {
							return {
								_id: signup._id, 
								status: _.isNil(registration.capacity) ? 'Registered' : signup._displayOrder < registration.capacity ? 'Registered' : 'Waitlisted',
								comments: null,
								user: {
									_id: guest.resident.user?._id
								}
							}
						}
					});
				}

				const user = {
					_id: signup.user._id,
					firstName: signup.user.preferredName || signup.user.firstName, 
					lastName: signup.user.lastName,
					fullName: `${signup.user.preferredName || signup.user.firstName} ${signup.user.lastName}`
				}

				if (signup.user._type == 'resident') {
					user.optOutOfDirectory = signup.user._optOutOfDirectory;
				}

				const mapped =  {
					_id: signup._id, 
					status: _.isNil(registration.capacity) ? 'Registered' : signup._displayOrder < registration.capacity ? 'Registered' : 'Waitlisted',
					comments: signup.comments || null,
					user,
					__typename: 'UserRSVP'
				}

				return [mapped, guests]
			});
		}

		// map virtualEventDestinations & urlDetails
		let urlDetails = {};
		let virtualEventDestinations = [];
		if (_.get(occurrence, 'virtual._slideshow')) {

			const slideshow = occurrence.virtual._slideshow;

			// map virtual destinations
			if (slideshow.destination && slideshow.destination.length > 0) {
				virtualEventDestinations = _.map(slideshow.destination, (dest)=> {
					return { _id: dest._id, name: dest.name }
				});
			}

			// map link and video slides
			const videos = _.filter(slideshow.slides, ['_type', 'video']);
			const links = _.filter(slideshow.slides, ['_type', 'link']);

			if (videos && videos.length > 0) {
				urlDetails = {
					type: 'video',
					provider: videos[0].video.provider,
					title: videos[0].video.title,
					previewImage: videos[0].video.thumbnail
				}
			} else if (links && links.length > 0) {
				urlDetails = {
					type: 'web',
					title: links[0].link.title,
					previewImage: links[0].link.thumbnail
				}
			}
		}
		
		const { name, description, _location, start, end, allDay } = occurrence;

		return {
			_id: eventId, 
			name, 
			openSpots: registration.capacity ? Math.max(registration.capacity - rsvps.length, 0) : null,
			totalSpots: registration.capacity, 
			location: _location._name,
			startsAt: start, 
			endsAt: end, 
			costsMoney: !!(registration._paymentRequired),
			allDay, 
			description,
			url: _.get(occurrence, 'virtual.url') || null,
			urlDetails,
			commentPrompt: registration._commentPrompt || null,
			signupUrl: registration.url || null,
			calendars,
			rsvps,
			virtualEventDestinations
		}

	},

	async getMyEvents()
	{

		const signups = await papi.events.signup.getMy({ 
			populate: 'event,event:_location,event:virtual:_slideshow:destination,event:virtual:_slideshow:slides:video,event:virtual:_slideshow:slides:link', 
			filter: JSON.stringify({ start: { $gte: new Date().toISOString() } }),
			sort: 'start'
		});
		// const events = await papi.events.signup.get();
		// console.log(events)
		// const response = await this.query({
		// 	query: MyEvents
		// })
		const mapped = [];

		for (const signup of signups) {

			const { event, start } = signup;

			const occurrence = { ...event, start }
			
			// merge any details from additional occurrences
			if (_.find(event.additionalOccurrences, ['start', occurrence.start])) {
				const details = _.find(event.additionalOccurrences, ['start', occurrence.start]);
				if (details.end != details.start) {
					occurrence.end = details.end
				} else {
					const duration = new Date(event.end).getTime() - new Date(event.start).getTime();
					const startDate = new Date(occurrence.start);
					occurrence.end = new Date(startDate.getTime() + duration).toISOString()
				}
	
				if (details.name) occurrence.name = details.name;
				if (details.description) occurrence.description = details.description;
	
	
				if (details.location && !_.isEmpty(details.location)) {
					occurrence._location = { _name: details.location.name };
				}
	
				if (details.registration && !_.isEmpty(details.registration)) {
					occurrence.registration = _.merge({}, event.registration, details.registration);
				}
	
				if (details.virtual && !_.isEmpty(details.virtual)) {
					occurrence.virtual = _.merge({}, event.virtual, details.virtual);
				}
	
				if (!_.isNil(details.allDay)) {
					occurrence.allDay = details.allDay;
				}
	
				if (details.cost && !_.isEmpty(details.cost)) {
					occurrence.cost = _.merge({}, event.cost, details.cost);
				}
				
			} else if (occurrence.start == event.start) {
				// occurrence is first or only occurrence in series, so just use end from event
				occurrence.end = event.end;
			} else {
				// calculate end using the duration of first event in series
				const duration = new Date(event.end).getTime() - new Date(event.start).getTime();
				const startDate = new Date(occurrence.start);
				occurrence.end = new Date(startDate.getTime() + duration).toISOString()
			}
			
			const { registration } = occurrence;
			
			if (start !== event.start) {
				occurrence._id = utils.getInstanceIdByEventIdAndStart(event._id, start);
			} else {
				occurrence._id = event._id; // use the actual event id if the event isn't recurring
			}

			const otherSignups = await papi.events.signup.get({ event: event._id, start, populate: 'user,guests:resident:user' });
			let rsvps = []

			if (otherSignups && otherSignups.length > 0) {
				rsvps = _.flatMapDeep(otherSignups, (signup)=> {
					let guests = []
					if (signup.guests && signup.guests.length > 0) {
						guests = _.map(signup.guests, (guest)=> {
							if (guest._type == 'nonResident') {
								return {
									_id: signup._id, 
									status: _.isNil(registration.capacity) ? 'Registered' : signup._displayOrder < registration.capacity ? 'Registered' : 'Waitlisted',
									comments: null,
									user: {
										fullName: `${signup.user.preferredName || signup.user.firstName} ${signup.user.lastName}`,
										_id: signup.user._id
									},
									guestName: guest.nonResident?.name ?? strings.events.guestLabel,
									__typename: 'GuestRSVP'
								}
							} else {
								return {
									_id: signup._id, 
									status: _.isNil(registration.capacity) ? 'Registered' : signup._displayOrder < registration.capacity ? 'Registered' : 'Waitlisted',
									comments: null,
									user: {
										_id: guest.resident.user?._id
									}
								}
							}
						});
					}
	
					const user = {
						_id: signup.user._id,
						firstName: signup.user.preferredName || signup.user.firstName, 
						lastName: signup.user.lastName,
						fullName: `${signup.user.preferredName || signup.user.firstName} ${signup.user.lastName}`
					}
	
					if (signup.user._type == 'resident') {
						user.optOutOfDirectory = signup.user._optOutOfDirectory;
					}
	
					const mapped =  {
						_id: signup._id, 
						status: _.isNil(registration.capacity) ? 'Registered' : signup._displayOrder < registration.capacity ? 'Registered' : 'Waitlisted',
						comments: signup.comments || null,
						user,
						__typename: 'UserRSVP'
					}
	
					return [mapped, guests]
				});
			}
			

			let urlDetails = {};
			let virtualEventDestinations = [];
			if (_.get(occurrence, 'virtual._slideshow')) {

				const slideshow = occurrence.virtual._slideshow;

				// map virtual destinations
				if (slideshow.destination && slideshow.destination.length > 0) {
					virtualEventDestinations = _.map(slideshow.destination, (dest)=> {
						return { _id: dest._id, name: dest.name }
					});
				}

				// map link and video slides
				const videos = _.filter(slideshow.slides, ['_type', 'video']);
				const links = _.filter(slideshow.slides, ['_type', 'link']);

				if (videos && videos.length > 0) {
					urlDetails = {
						type: 'video',
						provider: videos[0].video.provider,
						title: videos[0].video.title,
						previewImage: videos[0].video.thumbnail
					}
				} else if (links && links.length > 0) {
					urlDetails = {
						type: 'web',
						title: links[0].link.title,
						previewImage: links[0].link.thumbnail
					}
				}
			} 


			const { name, description, _location, end, allDay } = occurrence;


			mapped.push({
				_id: occurrence._id,
				name: name, 
				openSpots: registration.capacity ? Math.max(registration.capacity - rsvps.length, 0) : null,
				totalSpots: registration.capacity || null,
				location: _location._name,
				startsAt: start,
				endsAt: end,
				costsMoney: !!(registration._paymentRequired),
				allDay,
				description,
				url: _.get(occurrence, 'virtual.url') || null,
				urlDetails,
				commentPrompt: registration._commentPrompt,
				rsvps,
				virtualEventDestinations
			});
		}

		return mapped
		// return response.data.me.events;

	},

	async getMyInvites()
	{
		const invites = await papi.services.my.invites({ populate: 'user' });
		const userId = store.getters['user/id'];

		const mapped = [];
		for (const invite of invites) {

			const { _id, event, guests, start, user, _displayOrder } = invite;
			let instanceId;
			
			if (start !== event.start) {
				instanceId = utils.getInstanceIdByEventIdAndStart(event._id, start);
			} else {
				instanceId = event._id; // use the actual event id if the event isn't recurring
			}

			const idx = _.findIndex(guests, (guest)=> {
				if (guest._type === 'nonResident') return false;
				return guest.resident?.user == userId;
			});

			// just a precaution, would only throw if a bug is present in camelot /my/events/event
			if (idx === -1) {
				throw new Error('Invite not found');
			}

			const inviteId = utils.getGuestSignupId(_id, idx);

			let end;
			let occurrence = { ...event, start }

			if (_.find(event.additionalOccurrences, ['start', occurrence.start])) {
				const details = _.find(event.additionalOccurrences, ['start', occurrence.start]);
				if (details.end != details.start) {
					occurrence.end = details.end
				} else {
					const duration = new Date(event.end).getTime() - new Date(event.start).getTime();
					const startDate = new Date(occurrence.start);
					occurrence.end = new Date(startDate.getTime() + duration).toISOString()
				}
				end = occurrence.end;
	
				if (details.name) occurrence.name = details.name;
				if (details.description) occurrence.description = details.description;
	
	
				if (details.location && !_.isEmpty(details.location)) {
					occurrence._location = { _name: details.location.name };
				}
	
				if (details.registration && !_.isEmpty(details.registration)) {
					occurrence.registration = _.merge({}, event.registration, details.registration);
				}
	
				if (details.virtual && !_.isEmpty(details.virtual)) {
					occurrence.virtual = _.merge({}, event.virtual, details.virtual);
				}
	
				if (!_.isNil(details.allDay)) {
					occurrence.allDay = details.allDay;
				}
	
				if (details.cost && !_.isEmpty(details.cost)) {
					occurrence.cost = _.merge({}, event.cost, details.cost);
				}
				
			} else if (start == event.start) {
				// occurrence is first or only occurrence in series, so just use end from event
				end = event.end;
			} else {
				// calculate end using the duration of first event in series
				const duration = new Date(event.end).getTime() - new Date(event.start).getTime();
				const startDate = new Date(start);
				end = new Date(startDate.getTime() + duration).toISOString()
			}

			let otherSignups = await papi.events.signup.get({ event: event._id, start })
			otherSignups = _.sum(_.map(otherSignups, (item)=> {
				if (item.guests) {
					return item.guests.length + 1;
				} else {
					return 1;
				}
			}));

			mapped.push({
				_id: inviteId,
				signup: {
					_id: invite._id,
					status: _.isNil(occurrence.registration.capacity) ? 'Registered' : _displayOrder < occurrence.registration.capacity ? 'Registered' : 'Waitlisted',
					user: {
						fullName: `${user.preferredName || user.firstName} ${user.lastName}`
					},
					eventInstance: {
						_id: instanceId,
						name: occurrence.name,
						openSpots: occurrence.registration.capacity ? Math.max(occurrence.registration.capacity - otherSignups, 0) : null,
						totalSpots: occurrence.registration.capacity || null,
						location: occurrence._location._name,
						startsAt: start,
						endsAt: end,
						costsMoney: !!(occurrence.registration._paymentRequired),
						allDay: !!(occurrence.allDay)
					},
					event: {
						_id: event._id
					}
				}
			});
		}

		return mapped;
		// const response = await this.query({
		// 	query: MyInvites,
		// 	variables: {
		// 		status: 'Pending'
		// 	}
		// })

		// return response.data.me.invites;

	},

	async attendEvent(eventId, guests = [], comments = null)
	{

		const communityId = store.getters['user/communityId'];
		const userId = store.getters['user/id'];

		const { eventId: searchStr, start: instanceStart } = utils.getEventIdAndStartByInstanceId(eventId);

		let start = instanceStart;

		// get the id of the parent event
		const parentEvent = await papi.events.event.get({
			_id: new RegExp(`^${searchStr.substring(0, searchStr.length - 8)}`).toString(),
			select: '_id,registration,start'
		});

		if (parentEvent.length > 0 && eventId == parentEvent[0]._id) {
			start = parentEvent[0].start;
		}

		const camelotGuests = _.map(guests, (guest)=> {
			if (!_.isNil(guest.guestUserId)) {
				// guest is a resident
				return {
					_type: 'resident',
					resident: {
						user: guest.guestUserId
					}
				}
			} else {
				return {
					_type: 'nonResident',
					nonResident: {
						name: guest.guestName
					}
				}
			}
		});

		const signup = await papi.events.signup.createMy({
			event: parentEvent[0]._id,
			user: userId,
			start,
			paid: false,
			guests: camelotGuests,
			comments
		});

		return {
			user: {
				_id: userId,
				status: _.isNil(_.get(parentEvent[0].registration.capacity)) ? 'Registered' : signup._displayOrder < parentEvent[0].registration.capacity ? 'Registered' : 'Waitlisted'
			}
		}

		// const response = await this.mutate({
		// 	mutation: EventSignup,
		// 	variables: {
		// 		communityId, 
		// 		eventId,
		// 		userId,
		// 		guests,
		// 		comments
		// 	}
		// })

		// return response.data.community.event.signup;

	},

	async withdrawEvent(eventId, rsvpId)
	{
		// const communityId = store.getters['user/communityId'];

		await papi.events.signup.removeMy(rsvpId);
		return {
			_id: rsvpId,
			status: 'Withdrawn'
		}


		// const response = await this.mutate({
		// 	mutation: EventWithdraw,
		// 	variables: {
		// 		communityId, 
		// 		eventId,
		// 		rsvpId
		// 	}
		// })

		// return response.data.community.event.withdraw;

	},

	async acceptEvent(inviteId)
	{
		// const communityId = store.getters['user/communityId'];

		const invites = await papi.services.my.invites({});

		const pattern = new RegExp(`^${utils.getSignupIdPattern(inviteId)}`);

		const signup = _.find(invites, (invite)=> pattern.test(invite._id));

		if (!signup) {
			throw new Error('Invite not found', { cause: 404 });
		}

		await papi.services.my.accept(signup._id, {});

		const result = await papi.events.signup.getMy({ event: signup.event._id });

		return {
			signup: {
				_id: result._id,
				displayName: store.getters['user/fullName']
			},
			status: _.isNil(_.get(signup.event.registration.capacity)) ? 'Registered' : result[0]._displayOrder < signup.event.registration.capacity ? 'Registered' : 'Waitlisted'
		}

		// const response = await this.mutate({
		// 	mutation: EventAccept,
		// 	variables: {
		// 		communityId, 
		// 		inviteId
		// 	}
		// })

		// return response.data.community.acceptEventInvite;

	},

	async declineEvent(inviteId)
	{
		// const communityId = store.getters['user/communityId'];

		// const response = await this.mutate({
		// 	mutation: EventDecline,
		// 	variables: {
		// 		communityId, 
		// 		inviteId
		// 	}
		// })

		const invites = await papi.services.my.invites({});

		const pattern = new RegExp(`^${utils.getSignupIdPattern(inviteId)}`);

		const signup = _.find(invites, (invite)=> pattern.test(invite._id));

		if (!signup) {
			throw new Error('Invite not found', { cause: 404 });
		}

		await papi.services.my.decline(signup._id);

		return {
			signup: {
				_id: inviteId,
				displayName: store.getters['user/fullName']
			},
			status: 'Declined'
		}




		// return response.data.community.declineEventInvite;

	},

	async updateComment(rsvpId, eventId, comment)
	{

		// const communityId = store.getters['user/communityId'];

		// await this.mutate({
		// 	mutation: ModifySignupComment,
		// 	variables: {
		// 		communityId,
		// 		rsvpId,
		// 		eventId,
		// 		comment
		// 	}
		// })

		// patch the new comment to the signup
		await papi.services.my.comment(rsvpId, { comments: comment });
		// original handler doesn't return anything
	},

	// Shortcuts
	async getShortcuts() {

		const shortcuts = await papi.content.shortcut.get({ sort: '_displayOrder' });

		return _.map(shortcuts, (shortcut) => {
			
			const { _icon, _id, _name, _link, _type } = shortcut;
			return {
				icon: _icon,
				id: _id,
				link: _link,
				name: _name,
				type: _.startCase(_type)
			}

		});
	},


	jwt: null,
	client: null
}
